export enum LoadingState {
  IDLE,
  REQUESTED,
  DATA_FETECHED,
  ERROR,
}
